import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://bocadelraypath.com';
const SITE_NAME = 'Boca-Delray Pathology Laboratories';
// Shorter brand suffix for page titles: the full name pushes most titles past
// the ~70 characters Bing (and Google's snippet) will show.
const TITLE_SUFFIX = 'Boca-Delray Pathology';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const Seo = ({ title, description, path = '/', image = DEFAULT_IMAGE, noindex = false, jsonLd, brandFirst = false }) => {
  const url = `${SITE_URL}${path === '/' ? '' : path}`;
  // brandFirst (the homepage) leads with the full name, so brand searches match
  // the title the way directory listings of the lab do.
  const fullTitle = !title ? SITE_NAME : brandFirst ? `${SITE_NAME} | ${title}` : `${title} | ${TITLE_SUFFIX}`;
  const jsonLdList = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      {description ? <meta name="description" content={description} /> : null}
      <meta name="robots" content={noindex ? 'noindex, follow' : 'index, follow'} />
      {/* A canonical pointing elsewhere (path defaults to '/') while also
          sending noindex is a self-contradictory signal — omit it here. */}
      {noindex ? null : <link rel="canonical" href={url} />}

      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      {description ? <meta property="twitter:description" content={description} /> : null}
      <meta property="twitter:image" content={image} />

      {jsonLdList.map((entry, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
